import 'react-table-6/react-table.css'
import React, { Component } from 'react'
import { Button } from '@wfp/ui'
import { connect } from 'react-redux'
import { setNarrative, transitionProposed, transitionRequested } from '../actions/narrative'

class ButtonPanel extends Component {
  render() {
    const user_save_transition = this.props.narrative.user_can_save
      ? `save`
      : this.props.narrative.user_can_disclaimer
      ? `disclaimer`
      : this.props.narrative.user_can_comment
      ? `comment`
      : false
    // Note: This and server will need changing if a role is created that permits editing comment and disclaimer and nothing else
    return (
      <div className={this.props.wrapperClassName}>
        <span>
          {user_save_transition && (
            <Button
              // Note: Calls transitionRequested, not transitionProposed, as no user confirmation reqd before submit to API
              onClick={() =>
                this.props.transitionRequested(
                  this.props.narrative,
                  `${user_save_transition}_${this.props.narrative.state_name}`
                )
              }
              className='draft--submission-btn'>
              {this.props.narrative[`transition_label_${user_save_transition}`]}
            </Button>
          )}
          {this.props.narrative.user_can_resend_to_co && (
            <Button
              onClick={() => this.props.transitionProposed(this.props.narrative, `resend_to_co`)}
              className='draft--submission-btn'>
              {this.props.narrative[`transition_label_resend_to_co`]}
            </Button>
          )}
          {this.props.narrative.user_can_resend_to_rb && (
            <Button
              onClick={() => this.props.transitionProposed(this.props.narrative, `resend_to_rb`)}
              className='draft--submission-btn'>
              {this.props.narrative[`transition_label_resend_to_rb`]}
            </Button>
          )}
          {this.props.narrative.user_can_submit_to_rb && (
            <Button
              onClick={() => this.props.transitionProposed(this.props.narrative, `submit_to_rb`)}
              className='draft--submission-btn'>
              {this.props.narrative[`transition_label_submit_to_rb`]}
            </Button>
          )}
          {this.props.narrative.user_can_submit_to_hq && (
            <Button
              onClick={() => this.props.transitionProposed(this.props.narrative, `submit_to_hq`)}
              className='draft--submission-btn'>
              {this.props.narrative[`transition_label_submit_to_hq`]}
            </Button>
          )}
          {this.props.narrative.user_can_duplicate_and_draft && (
            <Button
              onClick={() => this.props.transitionProposed(this.props.narrative, `duplicate_and_draft`)}
              className='draft--submission-btn'>
              {this.props.narrative[`transition_label_duplicate_and_draft`]}
            </Button>
          )}
          {this.props.narrative.user_can_publish && (
            <Button
              onClick={() => this.props.transitionProposed(this.props.narrative, `publish`)}
              className='draft--submission-btn'>
              {this.props.narrative[`transition_label_publish`]}
            </Button>
          )}
        </span>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  narrative: state.narrative.narrative,
  currentTab: state.appSettings.currentTab,
  userRole: state.appSettings.userInfo ? state.appSettings.userInfo.role : null,
})

const mapDispatchToProps = {
  setNarrative,
  transitionProposed,
  transitionRequested,
}

ButtonPanel = connect(
  mapStateToProps,
  mapDispatchToProps
)(ButtonPanel)

export default ButtonPanel
